<template>
  <div class="c-emptySupplier">
    <div class="m-emptyState m-emptyState--large">
      <slot name="title"></slot>

      <p class="m-emptyState_subtitle">
        Vamos juntos nos conectar com fornecedores da sua região!
        <a class="c-emptySupplier_button" :href="smartQuotationLink" >Faça uma Cotação Inteligente</a>
      </p>
      <slot name="image"></slot>
      <slot name="paragraph"></slot>
    </div>
    <p class="m-paragraphText m-paragraphText--center s-marginTop-sm s-marginBottom-none">
      <a :href="supplierUrl" class="m-linkText" >
        É fornecedor? Cadastre aqui sua empresa
      </a>
    </p>
  </div>
</template>

<script>
import { landingSupplier } from 'routes'
import { categoryQuotation } from 'routes'
import { mapState } from 'vuex'

export default {
  mounted(){
    var dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'providerListEmpty',
      'isLogged': this.isAuthenticated,
      'specialty': this.slug.category,
    })
  },

  computed: {
    ...mapState({
      slug: state => state.categoryDirectory.info.slug,
      isAuthenticated: state => state.account.authenticated
    }),

    supplierUrl() {
      return landingSupplier.index
    },

    smartQuotationLink() {
      const { category, serviceType } = this.slug

      return categoryQuotation.serviceType(category, serviceType)
    },
  },
}
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/box";
@import "~css/Modules/button";

.c-emptySupplier {
  @extend .m-box;
  @extend .m-box--large;

  @include f-media('<tablet') {
    .m-paragraphText {
      font-size: 14px;
    }
  }

  &_grid {
    display: flex;
    flex-flow: column wrap;
    margin-top: $v-gap-md;
    align-items: center;
  }

  &_button {
    @extend .m-button;
    @extend .m-button--small;
    max-width: 270px;
    margin: $v-gap-xxs;
    margin: $v-gap-sm auto $v-gap-lg;
  }
}
</style>